import {
  VuexModule,
  Module,
  Action,
  getModule,
  Mutation,
} from "vuex-module-decorators";
import store from "./index";
import notificationService, {
  BaseMailParams,
} from "@/services/api/notification.api";
import { ListOptions } from "@/services/api/types";
import { Message } from "@/types";
import { Dictionary } from "vue-router/types/router";
import { downloadFileLink } from "@/utils";
import notificationApi from "@/services/api/notification.api";
import { SendMessage } from "@/types/notifications";

@Module({ dynamic: true, store, name: "mail", namespaced: true })
class MailModule extends VuexModule {
  message: Message | null = null;
  notificationsCount: Dictionary<number | null> = {};

  @Mutation
  public setMessage(value: Message | null) {
    this.message = value;
  }

  @Mutation
  public setNotificationsCount(
    resNotificationsCount: Dictionary<number | null>,
  ) {
    let all = 0;
    for (const key in resNotificationsCount) {
      if (resNotificationsCount[key] == 0) {
        resNotificationsCount[key] = null;
      } else {
        all += resNotificationsCount[key]!;
      }
    }
    if (resNotificationsCount.unreadNotifications == all) return;
    resNotificationsCount.unreadNotifications = all;
    this.notificationsCount = resNotificationsCount;
  }

  @Action
  public async getLawmen() {
    try {
      return (await notificationService.getLawmen()).data;
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  @Action
  public async replyToMessage(message: SendMessage) {
    try {
      notificationService.sendMessage(message);
      this.getNotificationsCount();
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  @Action
  public async getMessages(p: {
    options: ListOptions;
    filter: BaseMailParams;
  }) {
    try {
      return (await notificationService.getMessages(p.options, p.filter)).data;
    } catch (e) {
      console.error(e);
    }
  }

  @Action
  async setRead(
    notificationGuid: string,
    notificationId: string,
    isNotification?: boolean,
  ) {
    await notificationService.setRead(
      notificationGuid,
      notificationId,
      isNotification,
    );
    this.getNotificationsCount();
  }

  @Action
  async getNotificationsCount() {
    try {
      const res = await notificationService.getCount();
      if (typeof res.data == "object") this.setNotificationsCount(res.data);
    } catch (e) {
      console.error(e);
    }
  }

  @Action
  async downloadMessageFile(
    docGuid: string,
    messageGuid: string,
    messageId: number,
  ) {
    try {
      const res = await notificationApi.downloadMessageFile(
        docGuid,
        messageGuid,
        messageId,
      );

      if (typeof res.data != "object") return;

      this.setNotificationsCount(res.data);
      downloadFileLink(res);
    } catch (e) {
      console.log(e);
    }
  }
}

export default getModule(MailModule);
